import React from 'react';
import logoFasilkom2 from '../../../assets/images/bajo/logo-fasilkom-2.png';
import logoFasilkom from '../../../assets/images/bajo/logo-fasilkom.png';

const BajoContain = () => {
  const isFirstLinkActive = () => {
    const now = new Date();
    const activationDate = new Date('2025-06-26T09:00:00+07:00');
    return now >= activationDate;
  };
  const isSecondLinkActive = () => {
    const now = new Date();
    const activationDate = new Date('2025-06-26T19:00:00+07:00');
    return now >= activationDate;
  };
  const isThirdLinkActive = () => {
    const now = new Date();
    const activationDate = new Date('2025-06-27T19:00:00+07:00');
    return now >= activationDate;
  };
  const isFourthLinkActive = () => {
    const now = new Date();
    const activationDate = new Date('2025-06-28T19:00:00+07:00');
    return now >= activationDate;
  };

  const styles = {
    container: {
      position: 'relative',
      width: '100%',
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden',
      padding: '0 16px',
      color: 'white',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      background: 'linear-gradient(to top, #0077be, #66ccff)'
    },
    waveAnimation: {
      position: 'absolute',
      bottom: 0,
      width: '100%',
      height: '100px',
      opacity: 0.15,
      zIndex: 0,
      backgroundImage: `url("data:image/svg+xml;utf8,<svg width='1200' height='100' viewBox='0 0 1200 100' xmlns='http://www.w3.org/2000/svg'><path d='M0,30 C150,70 350,-10 600,30 C850,70 1050,-10 1200,30 L1200,100 L0,100 Z' fill='white' /></svg>")`,
      backgroundRepeat: 'repeat-x',
      backgroundPosition: 'bottom',
      backgroundSize: 'cover',
      animation: 'wave 30s linear infinite'
    },
    backgroundPattern: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      opacity: 0.2,
      backgroundImage: "url('your-ocean-pattern.png')"
    },
    mainContent: {
      textAlign: 'center',
      zIndex: 10,
      position: 'relative'
    },
    logoContainer: {
      marginBottom: '8px'
    },
    logo: {
      height: '144px',
      margin: '0 auto',
      '@media (min-width: 640px)': {
        height: '208px'
      }
    },
    title: {
      fontSize: '1.875rem', // text-3xl (30px)
      fontWeight: '900 !important', // font-extrabold dengan !important
      lineHeight: '1.1', // leading-tight
      textShadow: '2px 2px 0 #0077be', // text-outline effect
      fontFamily: '"Arial Black", "Helvetica Bold", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      '@media (min-width: 640px)': {
        fontSize: '3rem' // sm:text-5xl (48px)
      },
      '@media (min-width: 768px)': {
        fontSize: '4.5rem' // md:text-7xl (72px)
      }
    },
    titleBlock: {
      display: 'block'
    },
    exploreText: {
      color: '#fde047',
      fontStyle: 'italic',
      fontSize: '1.5rem',
      display: 'block',
      marginTop: '4px',
      marginBottom: '4px',
      '@media (min-width: 640px)': {
        fontSize: '2.25rem'
      },
      '@media (min-width: 768px)': {
        fontSize: '3rem'
      }
    },
    dateText: {
      marginTop: '4px',
      fontSize: '0.875rem',
      fontWeight: '700',
      letterSpacing: '0.1em',
      '@media (min-width: 640px)': {
        fontSize: '1.125rem'
      }
    },
    instructionContainer: {
      marginTop: '24px',
      fontSize: '0.875rem',
      '@media (min-width: 640px)': {
        fontSize: '1rem'
      }
    },
    comingSoon: {
      fontWeight: '600',
      color: '#fef3c7'
    },
    activeLink: {
      color: '#fde047',
      textDecoration: 'underline',
      fontWeight: '600',
      cursor: 'pointer',
      transition: 'color 0.3s ease'
    }
  };

  return (
    <>
      <style>
        {`
          @keyframes wave {
            0% { background-position-x: 0; }
            100% { background-position-x: 1000px; }
          }
          
          .responsive-title {
            font-weight: 900 !important;
            font-family: "Arial Black", "Helvetica Bold", sans-serif !important;
          }
          
          .active-link:hover {
            color: #ffffff !important;
          }
          
          @media (min-width: 640px) {
            .responsive-logo {
              height: 208px !important;
            }
            .responsive-title {
              font-size: 3rem !important;
              font-weight: 900 !important;
            }
            .responsive-explore {
              font-size: 2.25rem !important;
            }
            .responsive-date {
              font-size: 1.125rem !important;
            }
            .responsive-instruction {
              font-size: 1rem !important;
            }
          }
          
          @media (min-width: 768px) {
            .responsive-title {
              font-size: 4.5rem !important;
              font-weight: 900 !important;
            }
            .responsive-explore {
              font-size: 3rem !important;
            }
          }
        `}
      </style>
      
      <div style={styles.container}>
        {/* Animasi ombak SVG */}
        <div style={styles.waveAnimation} />
        
        {/* Background sea pattern */}
        <div style={styles.backgroundPattern} />
        
        {/* Main Content */}
        <div style={styles.mainContent}>
          {/* Logo */}
          <div style={styles.logoContainer}>
            <img 
              src={logoFasilkom} 
              alt="Logo UI" 
              style={styles.logo}
              className="responsive-logo"
            />
          </div>
          
          {/* Judul */}
          <h1 style={styles.title} className="responsive-title">
            <span style={styles.titleBlock}>
              FASILKOM UI
            </span>
            <span style={{...styles.exploreText}} className="responsive-explore">
              Explore
            </span>
            <span style={styles.titleBlock}>
              LABUAN BAJO
            </span>
          </h1>
          
          {/* Tanggal */}
          <p style={styles.dateText} className="responsive-date">
            26 – 29 JUNI 2025
          </p>
          
          {/* Teks instruksi */}
          <div style={styles.instructionContainer} className="responsive-instruction">
            <p>Tekan link di bawah untuk melihat daftar Kamar, Bus dan Kapal:</p>
            <p>
              {isFirstLinkActive() && (
                <div style={styles.instructionContainer} className="responsive-instruction">
                  <p>Hari ke-1 Kamis, 26 Juni 2025</p>
                  <a 
                    href="https://lumbung.cs.ui.ac.id/seafhttp/f/3aceefe9e22e412bbe60/?op=view" 
                    style={styles.activeLink}
                    className="active-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Klik di sini
                  </a>
                </div>
              )}
              <div style={styles.instructionContainer} className="responsive-instruction">
                <p>Hari ke-2 Jum'at, 27 Juni 2025</p>
                <a 
                  href="https://lumbung.cs.ui.ac.id/seafhttp/f/c216269b09c348fe8a79/?op=view" 
                  style={styles.activeLink}
                  className="active-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  >
                  Klik di sini
                </a>
              </div>
              <div style={styles.instructionContainer} className="responsive-instruction">
                <p>Hari ke-3 Sabtu, 28 Juni 2025</p>
                <a 
                  href="https://lumbung.cs.ui.ac.id/seafhttp/f/4b8d0409658945d1a2b0/?op=view" 
                  style={styles.activeLink}
                  className="active-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  >
                  Klik di sini
                </a>
              </div>
              {isFourthLinkActive() && (
                <div style={styles.instructionContainer} className="responsive-instruction">
                  <p>Hari ke-4 Minggu, 29 Juni 2025</p>
                  <a 
                  href="https://lumbung.cs.ui.ac.id/seafhttp/f/1054a1dab368473299b4/?op=view" 
                    style={styles.activeLink}
                    className="active-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Klik di sini
                  </a>
                </div>
              )}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default BajoContain;